var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-top__language",staticStyle:{"user-select":"none"},on:{"click":_vm.toggleLanguage}},[_vm._v(" "+_vm._s(_vm.$i18n.locale)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }